import { getSelectedAttr } from "./general"
import { createSelector } from 'reselect'
import { getLayout, getNormalizedButtonsMap } from "./config";
import { getContrastHierarchy } from '../entities/general'
export const getRender = state => state.render;

export const getUpdatedRenderDetail = createSelector(
  getLayout,
  getRender,
  getSelectedAttr,
  (layout, updateRender, selectedAttr) => {
    const { attrName, attrValue } = selectedAttr
    Object.values(layout.sections).forEach((section) => {
      Object.values(section.enums).forEach((enumValue) => {
        if (enumValue.updateRender && enumValue.updateRender.indexOf(attrName) > -1) {
          updateRender = {
            ...updateRender,
            [enumValue.attrName]: {
              ...updateRender[enumValue.attrName],
              value: attrValue
            }
          }
        }
      })
    })
    return updateRender
  }
)


export const getUpdatedRenderFabric = createSelector(
  getRender,
  getSelectedAttr,
  (updateRender, selectedAttr) => {
    const { attrValue } = selectedAttr
    let nextRender = { ...updateRender }
    for (let renderKey in nextRender) {
      const parts = nextRender[renderKey].parts
      for (let partKey in parts) {
        if (parts[partKey].material === 'fabric') {
          nextRender = {
            ...nextRender,
            [renderKey]: {
              ...nextRender[renderKey],
              parts: {
                ...nextRender[renderKey].parts,
                [partKey]: {
                  ...nextRender[renderKey].parts[partKey],
                  materialValue: attrValue
                }
              }
            }
          }
        }
      }
    }
    return nextRender
  }
)



export const getUpdatedRenderButtons = createSelector(
  getNormalizedButtonsMap,
  getRender,
  getSelectedAttr,
  (buttonsMap, updateRender, selectedAttr) => {
    const { attrValue } = selectedAttr
    //const button = buttonsMap.get(attrValue);

    let nextRender = { ...updateRender }
    for (let renderKey in nextRender) {
      const parts = nextRender[renderKey].parts
      for (let partKey in parts) {
        if (parts[partKey].material === 'buttons') {

          nextRender = {
            ...nextRender,
            [renderKey]: {
              ...nextRender[renderKey],
              parts: {
                ...nextRender[renderKey].parts,
                [partKey]: {
                  ...nextRender[renderKey].parts[partKey],
                  materialValue: attrValue,
                }
              }
            }
          }
          //
        }
      }
    }
    return nextRender
  }
)

export const getUpdatedRenderContrasts = createSelector(
  getRender,
  getContrastHierarchy,
  (updateRender, contrastHierarchy) => {
    const { value, section } = contrastHierarchy
    let nextRender = { ...updateRender }
    for (let renderKey in nextRender) {
      if (renderKey !== section) {
        continue;
      }

      for (let partKey of contrastHierarchy.parts) {
        nextRender = {
          ...nextRender,
          [renderKey]: {
            ...nextRender[renderKey],
            parts: {
              ...nextRender[renderKey].parts,
              [partKey]: {
                ...nextRender[renderKey].parts[partKey],
                materialValue: value
              }
            }
          }
        }
      }
    }
    return nextRender
  }
)
